import { RouteRecordRaw } from 'vue-router'

import { PO_CREATE_ANY } from './permissions'

const PurchaseOrdersList = () =>
  import(/* webpackChunkName: "purchase-orders-list" */ './pages/index.vue')
const PurchaseOrderForm = () =>
  import(/* webpackChunkName: "purchase-order-form" */ './pages/FormPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'ordenes-compra',
    name: 'purchase-orders',
    component: PurchaseOrdersList,
    meta: {
      title: 'Órdenes de compra',
      auth: {
        requiredPermission: 'purchase_orders.view',
        requiredModule: 'purchase_orders',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'ordenes-compra/nueva',
    name: 'purchase-orders-create',
    component: PurchaseOrderForm,
    meta: {
      title: 'Nueva orden de compra',
      auth: {
        requiredPermission: [...PO_CREATE_ANY],
        requiredModule: 'purchase_orders',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'ordenes-compra/:ulid',
    name: 'purchase-orders-edit',
    component: PurchaseOrderForm,
    meta: {
      title: 'Orden de compra',
      auth: {
        requiredPermission: 'purchase_orders.view',
        requiredModule: 'purchase_orders',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
